// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"f4bdd661","393":"e21a79e0","447":"b771b3b7","967":"385c255a"}[chunkId] + ".chunk.js";
};